export default __webpack_public_path__ + "static/media/insert-row-left.c0fb1b9a.svg";